import { Modal } from "react-bootstrap";
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import dayjs from 'dayjs';
import './ProductDetailsDialog.css';
import { useTranslation } from 'react-i18next';
import { BsInfinity } from "react-icons/bs";
import { useStoreState, useStoreDispatch, APP_STORE_ACTION } from '../common/storeContext'
import { useMiddletier } from "../common/middletier";
import { MdOutlineZoomOutMap } from "react-icons/md";

const ProductDetailsDialog = (props) => {
  // const [remainingTime, setRemainingTime] = useState(null);
  const appState = useStoreState()
  const { query } = useMiddletier();
  const [cartQuantity, setCartQuantity] = useState(1);
  const { getdata } = props
  const { t, i18n } = useTranslation();
  const appDispatch = useStoreDispatch()
  const [showContactImgDialog, setShowContactImgDialog] = useState(false);
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })

  const onClickImage = () => {
    setShowContactImgDialog(true)
  };

  const formatAmount = (amount, decimalPoint) => {
    const factor = Math.pow(10, 0);
    const truncatedAmount = Math.floor(amount * factor) / factor;
    const formattedAmount = truncatedAmount.toLocaleString(appState.currencyFormat?.locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return formattedAmount;
  }

  const changeQuantity = (newQuantity) => {
    if (newQuantity < 1) {
      newQuantity = 1;
    } else if (getdata.quantity !== -1 && newQuantity > getdata.quantity) {
      newQuantity = getdata.quantity;
    }
    setCartQuantity(newQuantity);
  };

  const onClickAddCart = (event, item) => {
    event.stopPropagation();
    const quantity = parseInt(cartQuantity, 10);
    // CHECK VALID QUANTITY
    if (!cartQuantity || isNaN(quantity) || quantity < 1) {
      appDispatch({
        type: APP_STORE_ACTION.SHOW_ALERT,
        payload: { description: `Please enter a valid quantity.`, typeAlert: 'error' }
      });
    }
    else {
      // GET CURRENT CART PRODUCT
      const getCartProduct = localStorage.getItem('cart_product');
      let addCartProduct = (getCartProduct !== null && typeof getCartProduct !== 'undefined') ? JSON.parse(getCartProduct) : []

      // CHECK PRODUCT CURRENT STATUS (EXP: QUANTITY)

      query({
        method: 'getMallProducts',
        params: [
          { code: 'tenant', graphqlType: 'String', required: false, value: appState?.tenant },
          { code: 'language', graphqlType: 'String', required: false, value: i18n.resolvedLanguage },
        ],
        attributes: []
      }).then(({ data }) => {

        // FIND PRODUCT
        const foundProduct = data['getMallProducts'].find(product => product.id === item.id);

        // IF FOUND PRODUCT
        if (foundProduct) {
          console.log('foundProduct')
          // CHECK PRODUCT QUANTITY 

          // IF PRODUCT QUANTITY === 0
          if (foundProduct.quantity === 0) {
            console.log('quantity0')

            // IF CART PRODUCT HAVE THIS PRODUCT , WILL REMOVE
            if (addCartProduct.length > 0) {
              const getRemoveProduct = addCartProduct.filter(item => item.id !== foundProduct.id);

              localStorage.setItem("cart_product", JSON.stringify(getRemoveProduct));

              appDispatch({
                type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
                payload: {
                  open: false,
                  cart: JSON.stringify(getRemoveProduct)
                }
              });
            }

            appDispatch({
              type: APP_STORE_ACTION.SHOW_ALERT,
              payload: { description: `The current inventory check indicates that the quantity of this mall product is 0; therefore, it cannot be added any further. It will be automatically removed from the previous additions.`, typeAlert: 'error' }
            });

            return;
          } else {

            // FIND PRODUCT 
            let checkProduct = addCartProduct.find(product => product.id === item.id);

            // IF CART PRODUCT HAVE THIS PRODUCT , WILL ADD CART QUANTITY 
            if (addCartProduct.length > 0 && typeof checkProduct !== 'undefined') {

              const newQuantity = checkProduct.cart_quantity + cartQuantity

              // IF CHECK PRODUCT QUANTITY CAN ADD 
              if ((foundProduct.quantity >= newQuantity || foundProduct.quantity === -1)) {
                checkProduct.cart_quantity += cartQuantity
                localStorage.setItem("cart_product", JSON.stringify(addCartProduct));

                appDispatch({
                  type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
                  payload: {
                    open: false,
                    cart: JSON.stringify(addCartProduct)
                  }
                });

                appDispatch({
                  type: APP_STORE_ACTION.SHOW_ALERT,
                  payload: { description: `Add Cart Successful`, typeAlert: 'success' }
                });

                props.onHide()

                return;

              }
              else {
                // IF CHECK PRODUCT CANNOT ADD 

                // IF THIS PRODUCT CURRENT QUANTITY IN CART IS MORE THAN STOCK
                if (checkProduct.cart_quantity > foundProduct.quantity) {
                  checkProduct.cart_quantity = foundProduct.quantity
                  localStorage.setItem("cart_product", JSON.stringify(addCartProduct));

                  appDispatch({
                    type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
                    payload: {
                      open: false,
                      cart: JSON.stringify(addCartProduct)
                    }
                  });

                  appDispatch({
                    type: APP_STORE_ACTION.SHOW_ALERT,
                    payload: { description: `The current stock for this product is only ${foundProduct.quantity} items, thus the quantity of this product added to the cart will be adjusted to ${foundProduct.quantity}.`, typeAlert: 'error' }
                  });
                  return
                } else {
                  return appDispatch({
                    type: APP_STORE_ACTION.SHOW_ALERT,
                    payload: { description: `You already have ${checkProduct.cart_quantity} quantity in cart.Unable To add selected quantity to cart as it would exceed your purchase limit`, typeAlert: 'error' }
                  });
                  // Quantity exceeds maximum limit of ${foundProduct.quantity}. Please decrease the quantity.
                }


              }

            } else {
              // IF CART PRODUCT DUN HAVE THIS PRODUCT , WILL DIRECT ADD CART  
              console.log('dun have any product just add')

              addCartProduct.push(
                {
                  id: item.id,
                  cart_quantity: cartQuantity
                })

              localStorage.setItem("cart_product", JSON.stringify(addCartProduct));

              appDispatch({
                type: APP_STORE_ACTION.SET_SHOPPING_CART_DIALOG,
                payload: {
                  open: false,
                  cart: JSON.stringify(addCartProduct)
                }
              });

              appDispatch({
                type: APP_STORE_ACTION.SHOW_ALERT,
                payload: { description: `Add Cart Successful`, typeAlert: 'success' }
              });
              props.onHide()
            }

          }
        }




      }).catch((error) => {

      })
    }

  };

  const resetQuantity = () => {
    setCartQuantity(1);
  };

  return (
    <>
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      id="productDetailsModal"
      onEnter={resetQuantity}
      fullscreen={isDesktopOrLaptop ? false : true}
      className={`${showContactImgDialog?'showBackdrop':''}`}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="subTitle">
          {t('product_details')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="productDetails_container">
          <figure>
            <div className="productDetails_imageWrap" onClick={onClickImage}>
              {(getdata?._desktop_image?.url || getdata?._mobile_image?.url) && (
                <img src={`${isDesktopOrLaptop ? (getdata?._desktop_image?.url) : (getdata?._mobile_image?.url)}`} alt={getdata.title} />
              )}
             {!isDesktopOrLaptop&&(<MdOutlineZoomOutMap/>)} 
            </div>

            {!isDesktopOrLaptop && (<figcaption>
              <div className="productDetails_point">
                {getdata?.promotion_point && (<div className="promotion_point">{formatAmount(getdata?.promotion_point ?? 0, appState.currencyFormat.decimal_point)}  <span className="point_name">{t('point')}</span></div>)}
                <div className={`product_point ${getdata?.promotion_point && 'discount'}`}>{formatAmount(getdata?.point ?? 0, appState.currencyFormat.decimal_point)} <span className="point_name"> {t('point')}</span></div>
              </div>

            </figcaption>)}
          </figure>

          <div className="productDetails_content">
            <div className="productDetails_title">{getdata?.name}</div>
            {isDesktopOrLaptop && (<> <div className="productDetails_point">
              {getdata?.promotion_point && (<div className="promotion_point">{formatAmount(getdata?.promotion_point ?? 0, appState.currencyFormat.decimal_point)}  <span className="point_name">{t('point')}</span></div>)}
              <div className={`product_point ${getdata?.promotion_point && 'discount'}`}>{formatAmount(getdata?.point ?? 0, appState.currencyFormat.decimal_point)} <span className="point_name"> {t('point')}</span></div>
            </div>
            </>)}
            <div className="productDetails_desc" dangerouslySetInnerHTML={{ __html: getdata?.content }}></div>
            <div className="productDetails_quantity">
              <div className="productDetails_quantity_left">{t('quantity')}</div>
              <div className="productDetails_quantity_right">
                {/* <div className="productDetails_stock">
                  {t('stock')} : {getdata?.quantity === -1 ? <BsInfinity /> : getdata?.quantity}
                </div> */}
                <div class="quantity_action_part">
                  <div className={`number-input-button left ${cartQuantity <= 1 ? 'disabled' : ''}`} onClick={() => cartQuantity > 1 && changeQuantity(cartQuantity - 1)}>-</div>
                  <input type="number" className="shoppingCartQuantity" value={cartQuantity} onChange={(e) => changeQuantity(parseInt(e.target.value, 10))} min="1" />
                  <div className={`number-input-button right ${getdata?.quantity !== -1 && cartQuantity >= getdata?.quantity ? 'disabled' : ''}`} onClick={() => (getdata?.quantity === -1 || cartQuantity < getdata?.quantity) && changeQuantity(cartQuantity + 1)}> + </div>
                </div>
              </div>
            </div>
            <div className="productDetails_button_wrap"> <button className="color_button font_button button_action productDetails_button" onClick={(event) => onClickAddCart(event, getdata)}>{t('add_to_cart')}</button></div>
          </div>
        </div>
      </Modal.Body>
    </Modal >
    {showContactImgDialog&&(<Modal show={showContactImgDialog}
        onHide={() => setShowContactImgDialog(false)}
        id="contactImgDialog"
        centered >
        <Modal.Body closeButton>
          <img src={`${isDesktopOrLaptop ? (getdata?._desktop_image?.url) : (getdata?._mobile_image?.url)}`} alt={'QR_IMAGE'} />
        </Modal.Body>
      </Modal>)
      }
    </>
  );
}

export default ProductDetailsDialog;
